import { render } from "./ColorDropdown.vue?vue&type=template&id=98c27c1e"
import script from "./ColorDropdown.vue?vue&type=script&lang=js"
export * from "./ColorDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__